import React from "react";
import { useTranslation } from 'react-i18next';
import { useSearchParams } from "react-router-dom";
import styles from "./products-card.module.scss";

const ProductCard = ({ name }: { name: string }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  
  const handleShowDetails = () => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("productName", name);
    setSearchParams(newParams);
  };

  const { t } = useTranslation();
  
  return (
    <div id={`product-closed-card-${name}`} className={`${styles.productCard} ${searchParams.get("productName") == name ? styles.opened : styles.closed}`}>
      <h3 className={searchParams.get("productName") == name ? styles.opened : styles.closed}>{name}</h3>
      <button className={`${styles.showDetails} ${searchParams.get("productName") == name ? styles.opened : styles.closed}`} onClick={handleShowDetails}>
        {t('products-card.showDetails')}
      </button>
    </div>
  );
};

export default ProductCard;
